import React from 'react';
import styled from 'styled-components/';

const ModalWindow = styled.div`
  position: fixed;
  background-color: rgba(38, 38, 38, 0.65);
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  & > div {
    width: 90%;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    padding: 2rem;
    background: #ffffff;
    border-radius: 5px;
  }
  &.modalVisible {
    visibility: visible;
    opacity: 1;
    pointer-events: auto;
  }
`;

const Modal = props => {
  return <ModalWindow className="modalVisible">{props.children}</ModalWindow>;
};

export default Modal;
